import { AvailablePaymentMethodsCard } from './AvailablePaymentMethodsCard'
import { AvailablePaymentMethodsDefault } from './AvailablePaymentMethodsDefault'
import type { AvailablePaymentMethodsProps } from './paymentMethods'

/**
 * Renders the payment methods available for a listing/checkout. `variant`
 * selects the chrome: `'default'` is the standalone grey block; `'card'` is the
 * LDP-redesign sidebar card. Both share the method-derivation brain in
 * ./paymentMethods.
 */
export const AvailablePaymentMethods = ({
  variant = 'default',
  ...props
}: AvailablePaymentMethodsProps & { variant?: 'default' | 'card' }) =>
  variant === 'card' ? (
    <AvailablePaymentMethodsCard {...props} />
  ) : (
    <AvailablePaymentMethodsDefault {...props} />
  )
